export enum TransportEndpoint {
  Base = '/tp',
  Loads = '/loads',
  TransportOrders = '/tos',
  Filters = '/filters',
}
